import type { EquipoDetalleDTO, EquipoDTO, EquipoInput, MantenimientoInput } from '@mg/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { get, post, put } from '@/lib/api.ts';

export interface FiltrosEquipos {
  q?: string | undefined;
  tipo?: string | undefined;
  activo?: 'true' | 'false' | undefined;
  limite?: number | undefined;
}
export interface PaginaEquipos {
  datos: EquipoDTO[];
  total: number;
}

export const useEquipos = (f: FiltrosEquipos) => useQuery({ queryKey: ['flota', 'lista', f], queryFn: () => get<PaginaEquipos>('/flota', f as Record<string, string | number | undefined>), placeholderData: (p) => p });
export const useEquipo = (id: string | null) => useQuery({ queryKey: ['flota', 'detalle', id ?? ''], queryFn: () => get<EquipoDetalleDTO>(`/flota/${id}`), enabled: !!id });

function useInvalidar() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['flota'] });
}
export function useGuardarEquipo() {
  const inv = useInvalidar();
  return useMutation({ mutationFn: ({ id, datos }: { id?: string | undefined; datos: EquipoInput }) => (id ? put<EquipoDetalleDTO>(`/flota/${id}`, datos) : post<EquipoDetalleDTO>('/flota', datos)), onSuccess: () => void inv() });
}
export function useRegistrarMantenimiento() {
  const inv = useInvalidar();
  return useMutation({ mutationFn: ({ id, datos }: { id: string; datos: MantenimientoInput }) => post<EquipoDetalleDTO>(`/flota/${id}/mantenimientos`, datos), onSuccess: () => void inv() });
}
export function useAnularMantenimiento() {
  const inv = useInvalidar();
  return useMutation({ mutationFn: ({ id, mid, motivo }: { id: string; mid: string; motivo: string }) => post<EquipoDetalleDTO>(`/flota/${id}/mantenimientos/${mid}/anular`, { motivo }), onSuccess: () => void inv() });
}
